import { Map as V1Map  } from './v1';
import { Map as V2Map  } from './v2';

export class ExcelMap {
  // static to   = V1Map.to;
  static from = V2Map.from;

  static V1   = V1Map;
  static V2   = V2Map;
}

export type { Types as ExcelV1Types } from './v1';
export type { Types as ExcelV2Types } from './v2';